import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import AlertsContainer from './state/AlertsContainer';

export function useOrgProductFetching() {
    const { t, i18n } = useTranslation();
    const { organizationId } = useParams<{ organizationId: string }>();
    const { showError } = AlertsContainer.useContainer();
    const {
        orgProductsRef,
        orgProducts,
        loadingDataRef,
        loadingData,
        handleLoadingDataChange,
        getOrganizationProducts,
    } = OrganizationContainer.useContainer();

    useEffect(() => {
        async function initializeOrgProducts() {
            if (!organizationId || loadingDataRef.current.products == true) return;
            handleLoadingDataChange('products', true);
            const product = orgProductsRef.current.find((p) => p.organizationId === organizationId);

            if (product) {
                handleLoadingDataChange('products', false);
                return;
            }

            try {
                await getOrganizationProducts(organizationId, i18n.language);
            } catch (error) {
                showError(t('common:license.key.product.error.title'));
            } finally {
                handleLoadingDataChange('products', false);
            }
        }
        initializeOrgProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { orgProducts, isLoading: loadingData.products };
}
